import './../common/base';
import Vue from './common/vue-common';
import CollapsibleList from './components/common/CollapsibleList';

new Vue({
    el: '#shirts-black-friday-content-vue',
    components: { CollapsibleList },
    data() {
        return {
            tips: [
                {
                    head: 'Atualize seus dados',
                    text: 'Dê uma boa checada nos seus dados. Imagine perder tempo lembrando sua senha em plena Black Friday? Entre no seu cadastro, veja se seu endereço e outras informações estão atualizadas.',
                },
                {
                    head: 'Marque o dia na agenda ou calendário no celular',
                    text: 'Já tem data marcada a Black Friday desse ano: dia 26 de novembro de 2021. Então, stay tuned!',
                },
                {
                    head: 'Escolha os produtos antes',
                    text: 'Geralmente as ofertas da Black Friday esgotam super rápido, então é legal já ter em mente o que você gostaria. Faça sua lista de desejos e deixe as escolhas salvas, assim, na hora é só fazer o pedido! Pense também que pode ser uma boa oportunidade para antecipar os presentinhos do Natal. ;)',
                },
                {
                    head: 'Cadastre seu email e nos salve como favoritos',
                    text: 'Só cadastrar seu email ali em cima para ficar por dentro de todas as novidades e esquentas pré Black Friday Chico Rei.',
                },
                {
                    head: 'Fique de olho em nossas redes sociais',
                    text: 'Por lá a notícia está sempre fresquinha, então siga e interaja com a gente. Iremos adorar te ver por lá!',
                },
            ],

            faq: [
                {
                    head: 'Posso alterar meu pedido depois de confirmado?',
                    text: 'Infelizmente não. Depois de confirmado o pedido, ele entrará em produção, impossibilitando qualquer alteração no pedido (como troca de estampa, tamanho, etc). Caso seja necessário, você poderá solicitar a troca pelo site após o recebimento do pedido.',
                },
                {
                    head: 'Escolhi uma camiseta que tem produção sob demanda. O que isto significa?',
                    text: 'A produção sob demanda é referente aos produtos que ainda não temos prontos em nosso estoque. Isso significa que ele será produzido especialmente para você, após você finalizar a compra. Ao selecionar um produto sob demanda e fechar seu pedido, este produto entrará em produção e será enviado após ficar pronto.',
                },
                {
                    head: 'Por que o prazo de entrega é tão longo?',
                    text: 'Nós desenvolvemos atualmente também uma produção sob demanda, além das camisetas em pronta-entrega. Com isso, aumentamos MUITO a variedade de estampas e tamanhos disponíveis em nosso site! Com está produção sob demanda, precisamos de um tempo maior para finalizar a produção do seu pedido, mantendo a qualidade Chico Rei de sempre. Ao selecionar o frete, você será informado da data final de entrega do seu pedido e este é o prazo para que receba os produtos Chico Rei na sua casa.',
                },
                {
                    head: 'Posso usar um cupom de desconto nas promoções de Black Friday?',
                    text: 'Não é possível usar cupons de desconto junto com as promoções da Black Friday.',
                },
                {
                    head: 'Recebi o meu pedido e não gostei. Posso fazer uma devolução?',
                    text: 'O prazo para solicitação de devolução é de sete (7) dias corridos após o recebimento da compra.',
                },
            ],
        };
    },
});
